import React from 'react';
import {Divider as MuiDivider} from "@material-ui/core";

const Divider = () => {
    return <MuiDivider/>
};

export default Divider;